import { render, staticRenderFns } from "./lvlHospital.vue?vue&type=template&id=38067468&scoped=true&"
import script from "./lvlHospital.vue?vue&type=script&lang=js&"
export * from "./lvlHospital.vue?vue&type=script&lang=js&"
import style0 from "./lvlHospital.vue?vue&type=style&index=0&id=38067468&prod&lang=scss&"
import style1 from "./lvlHospital.vue?vue&type=style&index=1&id=38067468&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38067468",
  null
  
)

export default component.exports